import { render, staticRenderFns } from "./task-rating.vue?vue&type=template&id=ffb9864c&"
import script from "./task-rating.vue?vue&type=script&lang=js&"
export * from "./task-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffb9864c')) {
      api.createRecord('ffb9864c', component.options)
    } else {
      api.reload('ffb9864c', component.options)
    }
    module.hot.accept("./task-rating.vue?vue&type=template&id=ffb9864c&", function () {
      api.rerender('ffb9864c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-rating.vue"
export default component.exports